"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = require("../../..");
var ActionItemToolTip = function ActionItemToolTip(_ref) {
  var target = _ref.target,
    children = _ref.children,
    message = _ref.message,
    displayTooltip = _ref.displayTooltip,
    placement = _ref.placement,
    noPointerEvent = _ref.noPointerEvent;
  return _react["default"].createElement(_react["default"].Fragment, null, children, _react["default"].createElement(_.ToolTip, {
    displayTooltip: displayTooltip,
    targetElement: target,
    message: message,
    placement: placement,
    noPointerEvent: noPointerEvent,
    mode: "dark"
  }));
};
ActionItemToolTip.propTypes = {
  children: _propTypes["default"].node,
  target: _propTypes["default"].string,
  message: _propTypes["default"].string,
  displayTooltip: _propTypes["default"].bool,
  placement: _propTypes["default"].string,
  noPointerEvent: _propTypes["default"].bool
};
var _default = exports["default"] = ActionItemToolTip;